import React, { useState, useEffect } from "react";

import * as api from '../api/index'

import {
  Typography,
  Button,
  IconButton,
  ButtonGroup,
  Modal,
  TextField,
  Divider,
} from "@material-ui/core";
import { useDiscount } from "../Context/DiscountContext";
import { useCart } from "../Context/CartContext";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
// import { makeStyles } from "@material-ui/core/styles";
import useStyles from "./CartStyles";

const CartSummary = ({ currency }) => {
    const classes=useStyles();
    const {
        discountType,
        discountVal,
        setDiscountVal,
        discountFlag,
        openDiscountbox,
        handleDiscountTypeChange,
        handleDisountBoxOpen,
        handleDisountBoxClose,
        handleAddDiscount,
        clearDiscount,
      } = useDiscount();
      const {
        cartItems,
        getTotalPrice,
        getSubTotalPrice,
      } = useCart();

      const isError =
      (discountType && discountVal > 100) || discountVal >= getSubTotalPrice();

// State for permissions and loading
const [canApplyDiscount, setCanApplyDiscount] = useState(false);
const [isAdmin, setIsAdmin] = useState(false);
const [loading, setLoading] = useState(true);

// Fetch permissions from database
useEffect(() => {
  const fetchPermissions = async () => {
    try {
      const profile = JSON.parse(localStorage.getItem("profile")) || {};
      if (!profile.token) throw new Error("No token found");
      setIsAdmin(profile?.result?.userType?.includes("admin") || false);

      const { data } = await api.getUserPermissions();
      setCanApplyDiscount(data.canApplyCustomDiscount || false);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching permissions:", error.message);
      setCanApplyDiscount(false); // Fallback to no permission
      setLoading(false);
    }
  };
  fetchPermissions();
}, []);

// Log discount details whenever they change
useEffect(() => {
  try {
    const subTotal = getSubTotalPrice();
    console.log("[CartSummary] DISCOUNT DETAILS:", {
      discountFlag,
      discountType: discountType ? "percentage" : "flat",
      discountVal: parseFloat(discountVal) || 0,
      originalSubTotal: subTotal,
      discountedSubTotal: subTotal - (discountFlag ? parseFloat(discountVal) : 0),
      discountApplied: discountFlag ? parseFloat(discountVal) : 0,
    });
  } catch (e) {
    // no-op
  }
}, [discountFlag, discountType, discountVal, cartItems, getSubTotalPrice]);

  return (
    <div className={classes.totalAmountSection}>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Sub-Total:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getTotalPrice().originalSubTotal.toFixed(2)}`}
        </span>
      </Typography>
      
      {/* Show Round-off Sub-Total Adjustment */}
      {Math.abs(getTotalPrice().roundoff) > 0.01 && (
        <Typography
          variant="body2"
          color="initial"
          className={classes.totalAmountText}
          style={{ fontSize: "0.85rem", color: "#666", marginLeft: "10px" }}
        >
          Round-off Sub-Total Adj:{" "}
          <span className={classes.amountValue} style={{
            color: (getTotalPrice().adjustedSubTotal - getTotalPrice().originalSubTotal) >= 0 ? "#008000" : "#ff0000"
          }}>
            {(getTotalPrice().adjustedSubTotal - getTotalPrice().originalSubTotal) >= 0 ? "+" : ""}
            {`${currency}${(getTotalPrice().adjustedSubTotal - getTotalPrice().originalSubTotal).toFixed(2)}`}
          </span>
        </Typography>
      )}
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Discount:{" "}
        <span className={classes.amountValue}>
          {discountVal && discountFlag && cartItems.length ? (
            <>
              <span>
                <Button
                  variant="contained"
                  color="lightGrey"
                  className={classes.button}
                  endIcon={<ClearIcon />}
                  onClick={clearDiscount}
                >
                  {currency}
                  {discountVal.toFixed(2)}
                </Button>
              </span>
            </>
          ) : (
            <>
            <IconButton
                disabled={loading || !cartItems.length || (!isAdmin && !canApplyDiscount)}
                aria-label="add"
                onClick={handleDisountBoxOpen}
                style={{
                  cursor: (loading || !cartItems.length || (!isAdmin && !canApplyDiscount)) ? 'not-allowed' : 'pointer'
                }}
              >
                <AddIcon fontSize="medium" />
              </IconButton>
              
            </>
          )}
        </span>
      </Typography>

      <Modal
        open={openDiscountbox}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDisountBoxClose();
          }
        }}
      >
        <div className={classes.modal}>
          <TextField
            error={isError}
            helperText={isError ? "Incorrect entry." : null}
            type="number"
            label="Discount"
            value={discountVal}
            onChange={(e) => {
              setDiscountVal(e.target.value);
            }}
            // Add your input field props here
          />
          <ButtonGroup
            disableElevation
            variant="contained"
            aria-label="Disabled elevation buttons"
            style={{ marginLeft: 10 }}
          >
            <Button
              onClick={handleDiscountTypeChange}
              color={discountType === false ? "primary" : "default"}
            >
              Flat
            </Button>
            <Button
              onClick={handleDiscountTypeChange}
              color={discountType ? "primary" : "default"}
            >
              %
            </Button>
          </ButtonGroup>
          <div className={classes.modalButtons}>
            <Button
              variant="contained"
              color="primary"
              disabled={isError}
              onClick={() => {
                handleAddDiscount(getSubTotalPrice().toFixed(2));
              }}
              className={classes.AddButtonModal}
            >
              Add
            </Button>
            <IconButton
              aria-label="clear"
              onClick={handleDisountBoxClose}
              style={{ marginTop: "auto" }}
            >
              <ClearIcon />
            </IconButton>
          </div>
        </div>
      </Modal>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Gst(18%):{" "}
        <span className={classes.amountValue}>
          {`${currency}${getTotalPrice().originalVat.toFixed(2)}`}
        </span>
      </Typography>
      
      {/* Show Round-off GST Adjustment */}
      {Math.abs(getTotalPrice().roundoff) > 0.01 && (
        <Typography
          variant="body2"
          color="initial"
          className={classes.totalAmountText}
          style={{ fontSize: "0.85rem", color: "#666", marginLeft: "10px" }}
        >
          Round-off GST Adj:{" "}
          <span className={classes.amountValue} style={{
            color: (getTotalPrice().adjustedVat - getTotalPrice().originalVat) >= 0 ? "#008000" : "#ff0000"
          }}>
            {(getTotalPrice().adjustedVat - getTotalPrice().originalVat) >= 0 ? "+" : ""}
            {`${currency}${(getTotalPrice().adjustedVat - getTotalPrice().originalVat).toFixed(2)}`}
          </span>
        </Typography>
      )}

      {/* Show Effective GST Total */}
      {Math.abs(getTotalPrice().roundoff) > 0.01 && (
        <Typography
          variant="body1"
          color="initial"
          className={classes.totalAmountText}
          style={{ fontSize: "1rem", color: "#000", marginLeft: "10px", fontWeight: "bold" }}
        >
          Effective GST:{" "}
          <span className={classes.amountValue} style={{ fontWeight: "bold", color: "#000" }}>
            {`${currency}${getTotalPrice().adjustedVat.toFixed(2)}`}
          </span>
        </Typography>
      )}
      
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Round Off:{" "}
        <span className={classes.amountValue} style={{
          color: getTotalPrice().roundoff >= 0 ? "#008000" : "#ff0000"
        }}>
          {getTotalPrice().roundoff >= 0 ? "+" : ""}{`${currency}${getTotalPrice().roundoff.toFixed(2)}`}
        </span>
      </Typography>
      
      
      <Divider />
      <Typography
        variant="h5"
        color="initial"
        className={classes.totalAmountText}
        style={{ marginTop: "10px" }}
      >
        Total Amount:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getTotalPrice().total.toFixed(2) || 0.0}`}
        </span>
      </Typography>
    </div>
  );
};

export default CartSummary;
